export const mergeStyles = (a, b, ...rest) => {
  const res = { ...a };
  b &&
    Object.keys(b).forEach(
      key => (res[key] = res[key] ? `${res[key]} ${b[key]}` : b[key])
    );
  return rest.length > 0 ? mergeStyles(res, ...rest) : res;
};
